import { Box, Stack, useTheme } from '@mui/material';

export const OnboardingStepper = ({
  length,
  currentIndex,
}: {
  length: number;
  currentIndex: number;
}) => {
  const { palette } = useTheme();
  const array = new Array(length).fill(null);
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={{
        px: 2,
        py: 1.5,
        backgroundColor: palette.background.paperLowElevation,
        borderRadius: 80,
      }}
    >
      {array.map((_, index) => {
        const isCurrentStep = currentIndex === index;
        return (
          <Box
            sx={{
              width: isCurrentStep ? 16 : 8,
              height: 4,
              borderRadius: 80,
              backgroundColor: isCurrentStep ? palette.text.primary : palette.secondary.border,
              transition: 'background-color 0.3s, width 0.3s',
            }}
          />
        );
      })}
    </Stack>
  );
};
